import { render, staticRenderFns } from "./HsmDnsTab.vue?vue&type=template&id=46515546&"
import script from "./HsmDnsTab.vue?vue&type=script&lang=js&"
export * from "./HsmDnsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports